import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsBurnupRoute: InvariantJiraRoute = {
	name: 'software-reports-burnup',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup',
};
